export default __webpack_public_path__ + "static/media/bronze-card.22903fa8.svg";